import * as angular from 'angular';
import { EventChannel } from './event-channel.factory';

export const event = angular.module('event', [])
	.factory('EventChannel', () => EventChannel)
	.name;
